import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../ui/Logo';
import { HeartIcon, MailIcon } from 'lucide-react';
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-navy text-white" data-id="element-27">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-28">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-29">
          {/* Logo and tagline */}
          <div className="col-span-1 md:col-span-1" data-id="element-30">
            <Logo className="text-white" data-id="element-31" />
            <p className="mt-4 text-sm text-white/80" data-id="element-32">
              Digital health reminder tools for families and carers across the
              UK.
            </p>
            <div className="mt-4 flex space-x-4" data-id="element-33">
              <div className="flex items-center text-sky-blue" data-id="element-34">
                <HeartIcon className="h-5 w-5 mr-2" data-id="element-35" />
                <span className="text-sm" data-id="element-36">UK-Based</span>
              </div>
            </div>
          </div>
          {/* Quick links */}
          <div className="col-span-1" data-id="element-37">
            <h3 className="text-lg font-bold mb-4" data-id="element-38">Quick Links</h3>
            <ul className="space-y-2" data-id="element-39">
              <li data-id="element-40">
                <Link to="/" className="text-white/80 hover:text-white transition-colors" data-id="element-41">
                  Home
                </Link>
              </li>
              <li data-id="element-42">
                <Link to="/features" className="text-white/80 hover:text-white transition-colors" data-id="element-43">
                  Features
                </Link>
              </li>
              <li data-id="element-44">
                <Link to="/pricing" className="text-white/80 hover:text-white transition-colors" data-id="element-45">
                  Pricing
                </Link>
              </li>
              <li data-id="element-46">
                <Link to="/about" className="text-white/80 hover:text-white transition-colors" data-id="element-47">
                  About Us
                </Link>
              </li>
              <li data-id="element-48">
                <Link to="/contact" className="text-white/80 hover:text-white transition-colors" data-id="element-49">
                  Contact Us
                </Link>
              </li>
              <li data-id="element-50">
                <Link to="/faq" className="text-white/80 hover:text-white transition-colors" data-id="element-51">
                  FAQs
                </Link>
              </li>
            </ul>
          </div>
          {/* Legal */}
          <div className="col-span-1" data-id="element-52">
            <h3 className="text-lg font-bold mb-4" data-id="element-53">Legal</h3>
            <ul className="space-y-2" data-id="element-54">
              <li data-id="element-55">
                <Link to="/privacy" className="text-white/80 hover:text-white transition-colors" data-id="element-56">
                  Privacy & Cookie Policy
                </Link>
              </li>
              <li data-id="element-57">
                <Link to="/terms" className="text-white/80 hover:text-white transition-colors" data-id="element-58">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>
          {/* Contact */}
          <div className="col-span-1" data-id="element-59">
            <h3 className="text-lg font-bold mb-4" data-id="element-60">Contact Us</h3>
            <ul className="space-y-3" data-id="element-61">
              <li className="flex items-start" data-id="element-62">
                <MailIcon className="h-5 w-5 mr-2 mt-0.5 text-sky-blue" data-id="element-63" />
                <a href="mailto:bhagatjenith3@gmail.com" className="text-white/80 hover:text-white transition-colors" data-id="element-64">
                  bhagatjenith3@gmail.com
                </a>
              </li>
            </ul>
            {/* Trust markers */}
            <div className="mt-6 grid grid-cols-2 gap-2" data-id="element-65">
              <div className="flex items-center bg-white/10 rounded p-2" data-id="element-66">
                <span className="text-xs" data-id="element-67">Data Secure</span>
              </div>
              <div className="flex items-center bg-white/10 rounded p-2" data-id="element-68">
                <span className="text-xs" data-id="element-69">Easy to Use</span>
              </div>
              <div className="flex items-center bg-white/10 rounded p-2" data-id="element-70">
                <span className="text-xs" data-id="element-71">Built for Families</span>
              </div>
              <div className="flex items-center bg-white/10 rounded p-2" data-id="element-72">
                <span className="text-xs" data-id="element-73">UK-Based</span>
              </div>
            </div>
          </div>
        </div>
        {/* Footer image */}
        <div className="mt-12 border-t border-white/20 pt-8" data-id="element-74">
          <div className="flex flex-col md:flex-row items-center justify-between" data-id="element-75">
            <div className="mb-4 md:mb-0" data-id="element-76">
              <img src="https://images.unsplash.com/photo-1569880153113-76e33fc52d5f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Senior using a smartphone with family member" className="h-20 rounded-lg" data-id="element-77" />
            </div>
            <p className="text-sm text-white/60" data-id="element-78">
              &copy; {currentYear} Artisanfix. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}